import React, { useState } from 'react';
import ToggleDescItem from './ToggleDescItem';

export function ToogleDescription({ itemsToggle }) {

  const [items] = useState(itemsToggle);
  const [descItems, setDescItems] = useState(itemsToggle[0])

  const descToggle = (item) => {
    setDescItems(item)
  }

  return (
    <div className="contentToggleDesc">
      <div className="toggleDesc">
        <div className="toggleDesc__left">
          <div className="toggleDesc__left--item isFirstOne"></div>
          {items.map(item => (
            <ToggleDescItem
              key={item.index}
              item={item}
              selected={descItems}
              descToggle={descToggle}
            />
          ))}
          <div className="toggleDesc__left--item isLast"></div>
        </div>
        <div className="toggleDesc__right">
          <div className="toggleDesc__right--title">
            <h1>{descItems.index}</h1>
            <h2>{descItems.title}</h2>
          </div>
          <div className="toggleDesc__right--content">
            <p> {descItems.desc} </p>
          </div>
        </div>
      </div>
    </div>
  )
}
